import { enableProdMode, provideZoneChangeDetection } from '@angular/core';
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';
import { RootBrowserModule } from './app/root/root-browser.module';
import { IEnvironment } from './environments/environment.model';
import { ShellDomainProvider } from './app/shared/standalone-packages/ecap3/core';
import { getRunTimeEnvironment } from './environments/runtime-environment';

export const environment: IEnvironment = getRunTimeEnvironment();
if (environment.production) {
    console.debug('Prod enabled');
    enableProdMode();
    window.console.log = (...params) => {
        if (window && window['enableStgConsole']) {
            window.console.info(...params);
        }
    };

    // window.console.debug = (...params) => {
    //     if (window && window['enableStgConsole']) {
    //         window.console.info(...params);
    //     }
    // };

    window.console.warn = () => {};
}

const browserLangKey = navigator.language.split('-')[0];
const isSupportedLang = environment.language.find(lang => lang.id === browserLangKey);
if (isSupportedLang) {
    environment.defaultLangKey = browserLangKey;
}

if (window) {
    console.log('setting in window');
    window['shellDomain'] = environment;
} else {
    console.log('setting in process.env');
    process.env['shellDomain'] = JSON.stringify(environment);
}
document.addEventListener('DOMContentLoaded', () => {
    ShellDomainProvider.init();
    platformBrowserDynamic()
        .bootstrapModule(RootBrowserModule, { applicationProviders: [provideZoneChangeDetection()], })
        .then(() => {
            if ('serviceWorker' in navigator && environment.production) {
                navigator.serviceWorker.register('ngsw-worker.js');
            }
        })
        .catch(err => console.log(err));
});

declare global {
    interface String {
    }
    interface Object {
        [key: string]: any;
    }
}

(String.prototype as any).replaceAll = function (replacee: string | RegExp, replacer: string) {
    const str = String(this);
    if (typeof replacee === 'string') {
        replacee = new RegExp(replacee, 'g');
    } else if (replacee instanceof RegExp) {
        replacee = new RegExp(replacee.source, replacee.flags.includes('g') ? replacee.flags : replacee.flags + 'g');
    }
    return str.replace(replacee, replacer);
};
